import { ApplyViaOptions } from 'src/types/linkOut';
import type { TealiumEventData } from 'src/types/trackingData';

const LINKOUT_APPLY_CLICKED = 'ecaja-shortlist-linkout-apply-clicked';

export const getLinkOutApplyClicked = (
  value: ApplyViaOptions,
): TealiumEventData => ({
  linkName: LINKOUT_APPLY_CLICKED,
  eventName: [LINKOUT_APPLY_CLICKED],
  isLinkOutApplyViaSeek: value === ApplyViaOptions.SEEK_WEBSITE,
});
